import { Form, Row } from "react-bootstrap";
import {
  Button,
  ButtonsContainer,
  DatePickerContainer,
  FormContainer,
  InputContainer,
} from "./style";
import { Controller, useForm } from "react-hook-form";
import { DropdownSelect } from "components/DropdownSelect";
import { CustomInput } from "components/CustomInput";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEmpresas } from "hooks/useEmpresas";
import { CustomDatePicker } from "components/DatePicker";
import { useState } from "react";
import { CustomInputModal } from "components/CustomInputModal";
import { FiltrosBloqueioAdministrativoSchema } from "../../validate/FiltroBloqueioAdministrativo";
import { IFiltroBloqueioAdministrativo } from "../../../../interfaces/IFiltroBloqueioAdministrativo";
import { useBloqueioAdministrativo } from "features/core/pages/Veiculo/pages/BloqueioAdministrativo/hooks/useBloqueioAdministrativo";

interface IProps {
  submitForm: (dados: IFiltroBloqueioAdministrativo) => void;
}

export function FiltroBloqueioAdministrativo({ submitForm }: IProps) {
  const { handleSubmit, control, setValue } = useForm({
    resolver: yupResolver(FiltrosBloqueioAdministrativoSchema),
  });

  const [inicioDataCadastro, setInicioDataCadastro] = useState<Date>();
  const [fimDataCadastro, setFimDataCadastro] = useState<Date>();
  const onChangeDataCadastro = (dates: any) => {
    const [start, end] = dates;
    setInicioDataCadastro(start);
    setFimDataCadastro(end);
  };

  const { empresasOptions, listarCnpjsIntegracaoFrotista, cnpjsOptions } =
    useEmpresas();
  const { validarLotes, validarVeiculos } = useBloqueioAdministrativo();

  const onClickLimpar = () => {
    setValue("idsLotes", null);
    setValue("dadosVeiculos", null);
    setValue("idEmpresa", null);
    setValue("cnpj", null);
    setValue("dataCriacaoLote", [null, null]);
    setFimDataCadastro(undefined);
    setInicioDataCadastro(undefined);
  };

  return (
    <FormContainer>
      <Form
        noValidate
        onSubmit={handleSubmit((dados: IFiltroBloqueioAdministrativo) =>
          submitForm(dados),
        )}
      >
        <Row className="mb-4">
          <InputContainer lg="4">
            <Form.Group>
              <Form.Label>ID Lote</Form.Label>
              <Controller
                control={control}
                name="idsLotes"
                defaultValue={[]}
                render={({ field: { onChange, value } }) => (
                  <CustomInputModal
                    label="Filtrar em massa"
                    value={value ?? []}
                    placeholder="Busque pelo lote"
                    onConfirm={onChange}
                    onClickOk={validarLotes}
                    validar={true}
                    style={{ width: "100%" }}
                    placeholderModal="Digite ou copie e cole os IDs dos lotes que deseja buscar e tecle ENTER"
                    labelItem="Recibo / NF"
                  />
                )}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer lg="4">
            <Form.Group>
              <Form.Label>Veículo</Form.Label>
              <Controller
                control={control}
                name="dadosVeiculos"
                defaultValue={[]}
                render={({ field: { onChange, value } }) => (
                  <CustomInputModal
                    label="Filtrar em massa"
                    value={value ?? []}
                    placeholder="Busque por placa, chassi ou renavam"
                    onConfirm={onChange}
                    onClickOk={validarVeiculos}
                    validar={true}
                    style={{ width: "100%" }}
                    placeholderModal="Digite ou copie e cole placa, chassi ou renavam dos veículos que deseja buscar e tecle ENTER"
                    labelItem="Veículos"
                  />
                )}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer lg="4">
            <Form.Group>
              <Form.Label>Empresa</Form.Label>
              <Controller
                control={control}
                name="idEmpresa"
                render={({ field: { onChange, value } }) => (
                  <DropdownSelect
                    options={empresasOptions}
                    title=""
                    selectedValue={value}
                    onSelect={(valor) => {
                      listarCnpjsIntegracaoFrotista(valor);
                      onChange(valor);
                      setValue("cnpj", null);
                    }}
                    searchable
                    required
                  />
                )}
              />
            </Form.Group>
          </InputContainer>
        </Row>
        <Row>
          <InputContainer lg="4">
            <Form.Group>
              <Form.Label>CNPJ</Form.Label>
              <Controller
                control={control}
                name="cnpj"
                render={({ field: { onChange, value } }) => (
                  <DropdownSelect
                    title=""
                    options={cnpjsOptions}
                    selectedValue={value}
                    onSelect={onChange}
                    disabled={!cnpjsOptions.length}
                  />
                )}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer lg="4">
            <Form.Group>
              <Controller
                control={control}
                name="dataCriacaoLote"
                render={({ field: { onChange } }) => (
                  <DatePickerContainer>
                    <span>Data de criação do lote</span>
                    <CustomDatePicker
                      selected={inicioDataCadastro}
                      onChange={(update) => {
                        onChange(update);
                        onChangeDataCadastro(update);
                      }}
                      startDate={inicioDataCadastro}
                      endDate={fimDataCadastro}
                      rangeSelect={true}
                    />
                  </DatePickerContainer>
                )}
              />
            </Form.Group>
          </InputContainer>
          <InputContainer lg="4">
            <Form.Group>
              <ButtonsContainer>
                <Button
                  type="reset"
                  outline
                  variante="primary"
                  style={{ marginRight: "8px", width: "76px" }}
                  onClick={onClickLimpar}
                >
                  Limpar
                </Button>
                <Button type="submit" style={{ width: "76px" }}>
                  Buscar
                </Button>
              </ButtonsContainer>
            </Form.Group>
          </InputContainer>
        </Row>
      </Form>
    </FormContainer>
  );
}
